module.exports = __webpack_public_path__ + "static/media/hims.e09611a8.webp";